import { graphql, useStaticQuery } from 'gatsby';
import React, { createContext, FC, ReactNode, useContext } from 'react';

import { SiteSettings } from './models';

const SiteSettingsContext = createContext<SiteSettings | null>(null);

type SiteSettingsProviderProps = {
  children: ReactNode;
};

type QueryData = {
  allContentstackSettings: {
    nodes: SiteSettings[];
  };
};

export const SiteSettingsProvider: FC<SiteSettingsProviderProps> = ({
  children,
}) => {
  const data = useStaticQuery<QueryData>(graphql`
    query SiteSettingsQuery {
      allContentstackSettings {
        nodes {
          ...SettingsFragment
        }
      }
    }
  `);

  const settings = data?.allContentstackSettings?.nodes?.[0] ?? null;

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
